'use strict';

/* Filters */

var filters = {};

filters.register = function(name, func) {
  /* if the app is in loading phase, register the controller in config phase */
  if (app.register == null) {
    app.config(function() {
      app.register.filter(name, func);
    });
  } else {
    /* if the app is already running just register the new controller */
    app.register.filter(name, func);
  }
  return func;
};

// Localization of enum values
// text can be comma-separated e.g. ("STAFF,FAMILY,SEASON" | enum : "PersonCategoryEnum")
// multiple enum types can be specified in arbitrary number, the first hit will be used
angular.module('cfn').filter('enum', [
  'Locale',
  function(Locale) {
    return function(text, type, type2, type3) {
      if (text == undefined || typeof text !== 'string') {
        return '';
      }

      function enumToLocaleKey(enumType, enumValue) {
        return 'enums.' + enumType + '.' + enumValue;
      }

      // All arguments after the text are enum types we want to check
      var possibleEnumTypes = Array.prototype.splice.apply(arguments, [1]);

      return (
        text
          // Split, map and join to allow to translation of multiple comma separated values
          .split(',')

          .map(function(text) {
            var localizedText = null;
            var bestMatchingEnum = null;

            for (var i = 0; i < possibleEnumTypes.length; i++) {
              var enumType = possibleEnumTypes[i];
              if (
                type != undefined &&
                Locale.has(enumToLocaleKey(enumType, text))
              ) {
                localizedText = Locale.get(enumToLocaleKey(enumType, text));
                break;
              } else if (bestMatchingEnum == null && enums[enumType]) {
                bestMatchingEnum = enums[enumType];
              }
            }

            // If nothing was found, show enum key, similar to translate filter would behave
            if (localizedText === null) {
              if (bestMatchingEnum != null) {
                localizedText = bestMatchingEnum[text];
              }
              if (!localizedText) {
                //last fallback
                localizedText = text;
              }
            }

            return localizedText;
          })
          .join(', ')
      );
    };
  }
]);

angular.module('cfn').filter('enumUnitFactor', function() {
  return function(text, type, type2, type3, type4) {
    var factor = 1;

    if (text == undefined) return factor;
    if (type == undefined) return factor;

    if (type != undefined && enums[type] != undefined && enums[type].unitFactor)
      factor = enums[type].unitFactor[String(text)];
    else if (
      type2 != undefined &&
      enums[type2] != undefined &&
      enums[type2].unitFactor
    )
      factor = enums[type2].unitFactor[String(text)];
    else if (
      type3 != undefined &&
      enums[type3] != undefined &&
      enums[type3].unitFactor
    )
      factor = enums[type3].unitFactor[String(text)];
    else if (
      type4 != undefined &&
      enums[type4] != undefined &&
      enums[type3].unitFactor
    )
      factor = enums[type4].unitFactor[String(text)];
    else return factor;
    return factor;
  };
});

angular.module('cfn').filter('path', function() {
  return function(entity, type) {
    var module = moduleRegistry.getModuleByEntity(entity);
    if (module) {
      var path = moduleRegistry.getModuleSettings(module, type + 'Path');
      if (path) return path;
    }
    return 'app/core/popups/';
  };
});

/**
 * The filter will replace all occurrences (in the string the filter is applied
 * to) of an enumeration key with the translated options.
 */
angular.module('cfn').filter('replaceByEnum', function() {
  return function(stringToReplace, nameOfEnumToReplace) {
    if (!stringToReplace) {
      return stringToReplace;
    }
    stringToReplace = stringToReplace.replace(new RegExp('\\|', 'g'), ', ');
    // enums is a global variable that conatins all known enumeration objects.
    var enumToReplace = enums[nameOfEnumToReplace];
    if (enumToReplace) {
      for (var i = 0; i < enumToReplace.options.length; i++) {
        var key = enumToReplace.options[i];
        var translatedValue = enumToReplace[key];
        //console.debug("would replace",stringToReplace,typeof(stringToReplace),key,translatedValue);
        stringToReplace = String(stringToReplace).replace(
          new RegExp(key, 'g'),
          translatedValue
        );
      }
    }
    return stringToReplace;
  };
});

angular.module('cfn').filter('asIcon', [
  'iconPathFilter',
  function(iconPathFilter) {
    return function(typ) {
      if (typ) {
        var pngName = typ.toLowerCase();
        return iconPathFilter(pngName) + 'black/' + pngName + '.png';
      } else {
        return null;
      }
    };
  }
]);

angular.module('cfn').filter('iconPath', function() {
  return function(entity) {
    var module = moduleRegistry.getModuleByEntity(entity);
    if (module) {
      var path = moduleRegistry.getModuleSettings(module, 'iconPath');
      if (path) return path;
    }
    return 'img/icons/';
  };
});

angular.module('cfn').filter('reportActivityMapping', function() {
  return function(text) {
    var mapping = {};

    mapping['SOWING'] = 'Aussaat';

    mapping['TOFERTILIZE'] = 'Duengung';

    mapping['HARVESTING'] = 'Ernte';
    mapping['MACHINE_EMPLOYMENT'] = 'Maschineneinsatz';
    mapping['STAFF_EMPLOYMENT'] = 'Personaleinsatz';

    return mapping[text];
  };
});

angular.module('cfn').filter('activityName', [
  'i18nFilter',
  function(i18nFilter) {
    return function(text) {
      var upperCaseText = text;
      if (upperCaseText) upperCaseText = text.toUpperCase(); // Workaround for legacy input
      return i18nFilter('enums.BookingActivitiesEnum.' + upperCaseText, text);
    };
  }
]);

angular.module('cfn').filter('activityNames', [
  'i18nFilter',
  function(i18nFilter) {
    return function(text) {
      if (text) {
        var result = '';
        var data = text.split(',');
        for (var i in data) {
          var d = data[i];
          if (result != '') result += ', ';
          result += i18nFilter('enums.BookingActivitiesEnum.' + d, d);
        }
        return result;
      }
      return undefined;
    };
  }
]);

angular.module('cfn').filter('activityIcon', function() {
  return function(text) {
    if (text) text = text.toUpperCase(); // Workaround for legacy input
    return 'activities/' + text; // .png is added by directive
  };
});

angular.module('cfn').filter('activityIcons', [
  'activityIconFilter',
  function(activityIconFilter) {
    return function(text) {
      if (text) {
        var result = '';
        var data = text.split(',');
        for (var i in data) {
          var d = data[i];
          if (result != '') result += ',';
          result += activityIconFilter(d);
        }
        return result;
      }
    };
  }
]);

/* Data types */
angular.module('cfn').filter('timeDuration', function() {
  return function(val) {
    if (val == undefined || val == null) {
      return '';
    }

    var seconds = Math.floor(val / 1000);
    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;
    var hour = Math.floor(minutes / 60);
    minutes -= hour * 60;

    var res = '';

    if (hour > 0) {
      res = hour + ' h ';
    }
    res += minutes + ' m ';
    res += seconds + ' s';
    return res;
  };
});

angular.module('cfn').filter('cfnGridRenderer', [
  '$sce',
  function($sce) {
    return function(text, func, rowIndex, column, rowObj) {
      if (func) {
        return $sce.trustAsHtml(func(rowIndex, column, text, rowObj));
      } else {
        console.error('function for renderer is undefined:', func, row, column);
        return 'function for renderer is undefined';
      }
    };
  }
]);

angular.module('cfn').filter('trustHtml', [
  '$sce',
  function($sce) {
    return function(result) {
      return $sce.trustAsHtml(result);
    };
  }
]);

angular.module('cfn').filter('journalMarkup', [
  '$sce',
  'DemoAccountService',
  function($sce, DemoAccountService) {
    return function(fieldVal) {
      // {Meier}[Person,15079cd5-5102-2363-1e39-2d2160553305] hat  mit {CLAAS AXION 850}[Machine,37cedb42-1789-6a76-66b4-3b4d20967d6e] unter Verwendung von Kaliumsulfat  "gran"   K+S Kali GmbH und Am Wald(5,9 ha mit 10,0 kg (1,7 kg pro ha)) gedüngt.
      /* for (var i = 0; i < s.length; i++) {
             var c = s.charAt(i);
             //console.log(s.charAt(i));
             }*/
      // der aufbau hier ist  {name}[type,id]
      var result = '';
      if (null === fieldVal) return result;
      var val = fieldVal;

      while (val.indexOf('{') != -1) {
        result += val.substr(0, val.indexOf('{')); // add the text before markup

        val = val.substr(val.indexOf('{') + 1);

        var text = val.substr(0, val.indexOf('}')); // text ist der komplette eintrag bis nach der klammer

        val = val.substr(val.indexOf('[') + 1); // der rest ist nach [

        // der inhalt ist bis ] und darin durch , getrennt
        var data = val.substr(0, val.indexOf(']')).split(','); // data[0] = type data[1] = id
        //            #/core/index
        var entityName = data[0];
        // entity starts lowecase
        entityName = entityName.charAt(0).toLowerCase() + entityName.slice(1);

        // CFNPOC-7674 These links don't work for the demo account since the ids are not correct in it.
        if (!DemoAccountService.isDemoAccount()) {
          result +=
            '<a href="#/core/' +
            entityName +
            '/' +
            data[1] +
            '" class="' +
            data[0] +
            '_journalLink journalLink">' +
            text +
            '</a>';
        } else {
          result += text;
        }
        // cut of the rest
        val = val.substring(val.indexOf(']') + 1);
      }

      result += val;
      result =
        '' +
        result
          .replaceAll(
            '\n',
            '<div style="margin-bottom:1px;border-top:2px solid #f5f5f5;"></div>'
          )
          .replaceAll('\r', ' ');
      //        console.debug("journal",result);
      return $sce.trustAsHtml(result);
    };
  }
]);

/**
 * Capitalizes word
 */
angular.module('cfn').filter('cap', function() {
  return function(title) {
    return title ? title.capitalize() : title;
  };
});

angular.module('cfn').filter('nonauthorizedAction', function() {
  return function(actionId) {
    // Disallow everything as this filter is deprecated
    return false;
    // return !app.hasModule(actionId);
  };
});

angular.module('cfn').filter('percentage', [
  '$filter',
  function($filter) {
    return function(number, digitCount) {
      var _digitCount = digitCount || 2;
      var _number = $filter('number')(parseFloat(number) * 100, _digitCount);

      if (_number === '') {
        return '';
      }

      return _number + '%';
    };
  }
]);

angular.module('cfn').filter('fmtNumber', function() {
  return function(number, minDigits, maximalDigits) {
    if (number == undefined || number == null) return '';
    var maxDigits = maximalDigits || minDigits;
    var num = parseFloat(number, 10);
    if (isNaN(num)) {
      return '';
    }

    var parts = num
      .toFixed(maxDigits)
      .toString()
      .split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (maxDigits !== minDigits) {
      var regex = new RegExp('0{1,' + (maxDigits - minDigits) + '}$');
      parts[1] = parts[1].replace(regex, '');
    }

    return parts[1] === '' ? parts[0] : parts.join(',');
  };
});

angular.module('cfn').filter('formatCurrency', [
  '$filter',
  function($filter) {
    return function(money) {
      if (money) {
        if (angular.isString(money)) {
          money = money.replace('EUR', '');
          money = money.replace('USD', '');
        }
        money = $filter('currency')(money, 'EUR');
      }
      return money;
    };
  }
]);

/*
 * indexToLetter
 * formats an integer to a capitel Letter e.g.: 1 -> "A"
 */
angular.module('cfn').filter('indexToLetter', function() {
  return function(index) {
    if (index === undefined || index === null || index === 0) return '';

    return String.fromCharCode(64 + index);
  };
});

angular.module('cfn').filter('e2e', function() {
  return function(name) {
    if (name) return 'test-' + name.toLowerCase();
    else return '';
  };
});

angular.module('cfn').filter('unique', function() {
  return function(items, filterOn) {
    if (filterOn === false) {
      return items;
    }

    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
      var hashCheck = {},
        newItems = [];

      var extractValueToCompare = function(item) {
        if (angular.isObject(item) && angular.isString(filterOn)) {
          return item[filterOn];
        } else {
          return item;
        }
      };

      angular.forEach(items, function(item) {
        var valueToCheck,
          isDuplicate = false;

        for (var i = 0; i < newItems.length; i++) {
          if (
            angular.equals(
              extractValueToCompare(newItems[i]),
              extractValueToCompare(item)
            )
          ) {
            isDuplicate = true;
            break;
          }
        }
        if (!isDuplicate) {
          newItems.push(item);
        }
      });
      items = newItems;
    }
    return items;
  };
});

/**
 * This filter will escape HTML code that is passed in, for when you have the great idea to allow user input in HTML code.
 */
angular.module('cfn').filter('escapeHtml', function() {
  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
  };
  return function(string) {
    return String(string).replace(/[&<>"'\/]/g, function(s) {
      return entityMap[s];
    });
  };
});

/**
 * Returns if the given module is known or also loaded.
 * @param mustHaveBeenLoaded checks also if the module was acctually loaded.
 */
angular.module('cfn').filter('isModuleKnown', [
  'moduleLoading',
  function(moduleLoading) {
    return function(moduleName, mustHaveBeenLoaded) {
      return moduleLoading.isModuleKnown(moduleName, mustHaveBeenLoaded);
    };
  }
]);

global.filters = filters;
